module.exports = __webpack_public_path__ + "img/0.7638e4a8.png";